import React from 'react'

function LoadingPage() {
    return <section className='pt-20 px-4'>
        <img src="/loading_monitor.gif" draggable={false} alt="Loading icon" className='w-52 mx-auto' />
    </section>
}

export default LoadingPage